export default __webpack_public_path__ + "static/media/title.729d5d0f.svg";